import { KYMW2400Model } from '../kymw2400.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * ページテンプレート一覧取得コマンド。
 * 全ページテンプレートの一覧を取得。
 *
 * @export GetAllPageTemplateService
 * @class GetAllPageTemplateService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetAllPageTemplateService extends PlessJsonResponderSub<any> {

  private model: KYMW2400Model = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * API呼び出し
   *
   * @param {KYMW2400Model} model モデルクラス
   * @memberof GetAllPageTemplateService
   */
  execute(model: KYMW2400Model) {
    this.model = model;
    this.send('getAllPageTemplate', new PlessRequest());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetAllPageTemplateService
   */
  success(data: any): void {
    this.model.updatePageTemplateList(data);
  }
}
